import { c as _c } from "react/compiler-runtime";
import { Heading, LayoutStack } from 'design-system/server';
import Image, { StaticImageData } from 'next/image';
import { usePathname } from 'next/navigation';
import { useTranslations } from 'next-intl';
import styles from './NotFound.module.css';
import Error404 from '@/assets/error404.svg';
import TextLink from '@/components/TextLink';
function NotFound() {
  const $ = _c(44);
  const t = useTranslations("nextjs");
  const pathname = usePathname();
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      font: "var(--betterplace-typography-heading-md"
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== t) {
    t1 = t("errors.messages.status.404.title");
    $[1] = t;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== t1) {
    t2 = <Heading level="heading-sm" style={t0}>{t1}</Heading>;
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== t) {
    t3 = t("errors.messages.status.404.reasoning");
    $[5] = t;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <br />;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== pathname) {
    t5 = <span className={styles.location}>{pathname}</span>;
    $[8] = pathname;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== t3 || $[11] !== t5) {
    t6 = <p>{t3}{t4}{t5}</p>;
    $[10] = t3;
    $[11] = t5;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== t2 || $[14] !== t6) {
    t7 = <LayoutStack space="200" className={styles.centeredContainer}>{t2}{t6}</LayoutStack>;
    $[13] = t2;
    $[14] = t6;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  let t8;
  if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <div className={styles.imageContainer}><Image src={Error404 as StaticImageData} alt="" fill={true} /></div>;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  let t9;
  if ($[17] !== t) {
    t9 = t("errors.messages.status.404.todo_headline");
    $[17] = t;
    $[18] = t9;
  } else {
    t9 = $[18];
  }
  let t10;
  if ($[19] !== t9) {
    t10 = <Heading level="heading-xs">{t9}</Heading>;
    $[19] = t9;
    $[20] = t10;
  } else {
    t10 = $[20];
  }
  let t11;
  if ($[21] !== t) {
    t11 = t("errors.messages.status.404.todo_1");
    $[21] = t;
    $[22] = t11;
  } else {
    t11 = $[22];
  }
  let t12;
  if ($[23] !== t11) {
    t12 = <li>{t11}</li>;
    $[23] = t11;
    $[24] = t12;
  } else {
    t12 = $[24];
  }
  let t13;
  if ($[25] !== t) {
    t13 = t("errors.messages.status.404.todo_2");
    $[25] = t;
    $[26] = t13;
  } else {
    t13 = $[26];
  }
  let t14;
  if ($[27] === Symbol.for("react.memo_cache_sentinel")) {
    t14 = <br />;
    $[27] = t14;
  } else {
    t14 = $[27];
  }
  let t15;
  if ($[28] !== t) {
    t15 = t("errors.messages.status.404.todo_2_cta");
    $[28] = t;
    $[29] = t15;
  } else {
    t15 = $[29];
  }
  let t16;
  if ($[30] !== t15) {
    t16 = <TextLink href="mailto:support@betterplace.org">{t15}</TextLink>;
    $[30] = t15;
    $[31] = t16;
  } else {
    t16 = $[31];
  }
  let t17;
  if ($[32] !== t13 || $[33] !== t16) {
    t17 = <li>{t13}{t14}{t16}</li>;
    $[32] = t13;
    $[33] = t16;
    $[34] = t17;
  } else {
    t17 = $[34];
  }
  let t18;
  if ($[35] !== t12 || $[36] !== t17) {
    t18 = <ul>{t12}{t17}</ul>;
    $[35] = t12;
    $[36] = t17;
    $[37] = t18;
  } else {
    t18 = $[37];
  }
  let t19;
  if ($[38] !== t10 || $[39] !== t18) {
    t19 = <LayoutStack space="200">{t10}{t18}</LayoutStack>;
    $[38] = t10;
    $[39] = t18;
    $[40] = t19;
  } else {
    t19 = $[40];
  }
  let t20;
  if ($[41] !== t19 || $[42] !== t7) {
    t20 = <LayoutStack space="400">{t7}{t8}{t19}</LayoutStack>;
    $[41] = t19;
    $[42] = t7;
    $[43] = t20;
  } else {
    t20 = $[43];
  }
  return t20;
}
export default NotFound;